import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    public appAgreementContentDom: any;
    checkcedAgreeList: Set<any> = new Set(); // 选择协议的set
    isCheckcedAgreeAll: boolean = false;
    public isReadCheckd: boolean = false;
    
    appList: any[] = [];
    //常用是否已经全选
    isCheckedAll: boolean = false;
    public checkedCategoryIds: any[] = [];
    public checkedCategoryData: any[] = [];
    public checkedAppIds: any[] = [];
    public activeModalVisible: boolean = false;
    public GUIDE_VERSION: string =  '1.0.0';
}


// WEBPACK FOOTER //
// ./src/display/platform/GettingStarted/Modules.State.ts